import { Component, OnInit } from '@angular/core'
import { AuthService } from '../../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import { MatButton } from '@angular/material/button'
import { TariffImportComponent } from '../../../features/tariff/tariff-import/tariff-import.component'
import { MatIconModule } from '@angular/material/icon'
import { TariffCreateComponent } from '../../../features/tariff/tariff-create/tariff-create.component'
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion'
import { MatProgressBar } from '@angular/material/progress-bar'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { TableListTariffComponent } from '../../../shared/components/table-list-tariff/table-list-tariff.component'
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator'
import { SearchTariffContractComponent } from '../../../features/tariff/search-tariff-contract/search-tariff-contract.component'
import { SearchTariffPageComponent } from '../../../features/tariff/search-tariff-page/search-tariff-page.component'
import { FormSearchProposalClientComponent } from '../../../shared/components/form-search-proposal-client/form-search-proposal-client.component'
import { TariffService } from '../../../core/services/tariff/tariff/tariff.service'
import { convertCurrency } from '../../../shared/utils/utils'
import { PagedContactTypeResponse } from '../../../core/models/contact-type.model'
import { TariffEditComponent } from '../../../features/tariff/tariff-edit/tariff-edit.component'
import { DialogLoadingComponent } from '../../../shared/components/dialog-loading/dialog-loading.component'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import { downloadBase64File } from '../../../shared/utils/download_base64'
import { ImportTariffService } from '../../../core/services/tariff/import-tariff/import-tariff.service'

@Component({
  selector: 'import-tariff',
  imports: [
    MatProgressBar,
    PaginationComponent,
    MatIconModule,
    TableListTariffComponent,
    MatPaginatorModule,
    SearchTariffContractComponent,
    SearchTariffPageComponent,
    FormSearchProposalClientComponent,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatButton,
    MatIconModule,
    TableListComponent,
  ],
  templateUrl: './import-tariff.component.html',
  styleUrl: './import-tariff.component.scss',
  providers: [AuthService],
  standalone: true,
})
export class ImportTariffComponent implements OnInit {
  constructor(
    private tariffService: TariffService,
    private importTariffService: ImportTariffService,
    private authService: AuthService,
    private dialog: MatDialog,
    private snackbar: SnackbarCustomService,
  ) {}

  page = 1
  rows = 10
  numberRows = 0
  itemsList: any[] = []
  loading = false
  searchForm: any = { search: false, model: {} }
  inputSearch = ''
  columns: any[] = [
    {
      keyColumn: 'userName',
      key: 'nomeUsuario',
      description: 'Responsável',
    },
    {
      keyColumn: 'tariffType',
      key: 'descricaoTipoTarifario',
      description: 'Tipo Tarifário',
    },
    {
      keyColumn: 'client',
      key: 'nomeCliente',
      description: 'Cliente/SubCliente',
    },
    {
      keyColumn: 'supplier',
      key: 'nomeFornecedor',
      description: 'Fornecedor',
    },
    {
      keyColumn: 'importDateTime',
      key: 'data_hora',
      description: 'Data - Hora',
    },
    {
      keyColumn: 'importStatus',
      key: 'descricaoStatus',
      description: 'Resultado',
    },
    {
      keyColumn: 'importTariffCount',
      key: 'totalInseridos',
      description: 'Total / Inseridos / Erros',
    },
    {
      keyColumn: 'action',
      key: { log: true, excel: true },
      description: 'Ações',
    },
  ]
  loadingModelo = false

  // screen: string = 'tarifário'
  screen = 'importação tarifário'

  ngOnInit() {
    this.checkColumnAction()
    this.getListItems()
    // this.logItem({ importTarifarioId: 2 })
  }

  checkColumnAction() {
    const index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        log: true,
        excel: true,
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  createModelSearch(search: any) {
    const model: any = {
      tipoTarifarioId: search.tipoTarifarioId,
      tarifarioStatus: search.tarifarioStatus,
      origemId: search.origemId,
      origem: search.origem,
      destinoId: search.destinoId,
      destino: search.destino,
      tipoServicoId: search.tipoServicoId,
      tipoServico: search.tipoServico,
      servicoId: search.servicoId,
      servico: search.servico,
      tipoVeiculoId: search.tipoVeiculoId,
      tipoVeiculo: search.tipoVeiculo,
      tipoMotoristaId: search.tipoMotoristaId,
      tipoMotorista: search.tipoMotorista,
      clienteId: search.clienteId,
      cliente: search.cliente,
      fornecedorId: search.fornecedorId,
      fornecedor: search.fornecedor,
      // standard: search.standard,
      standard: 'N',
      perimetroUrbano: search.perimetroUrbano,
      origemDescricao: search.origemDescricao,
      origemCidade: search.origemCidade,
      origemEstado: search.origemEstado,
      destinoDescricao: search.destinoDescricao,
      destinoCidade: search.destinoCidade,
      destinoEstado: search.destinoEstado,
    }
    return model
  }

  search(event: any) {
    this.page = 1
    if (event.search) {
      const model = this.createModelSearch(event.model)
      this.searchForm = { search: event.search, model: model }
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1 // pageIndex é zero-based, a sua variável page é 1-based
    this.rows = event.pageSize
    this.uploadList()
  }

  pageSizeChanged(newPageSize: number) {
    this.rows = newPageSize
    this.page = 1 // normalmente reseta para a primeira página
    this.uploadList()
  }

  uploadList(type = '') {
    if (type == 'new') {
      this.searchForm = { search: false, model: {} }
    }
    if (this.searchForm.search) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (let i = 0; i < response.data.length; i++) {
        const item = response.data[i]
        list.push({
          ...item,
          usuario: 'Root',
          data_hora: '16/10/205 - 10:00',
          result: 'Concluido',
        })
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  treatResponseSearch(response: any) {
    const list = []
    if (response.data && response.data.tarifarios) {
      for (const item of response.data.tarifarios) {
        list.push({
          ...item,
          custo_formatado: `R$ ${convertCurrency(item.custo)}`,
          custoHoraExtra_formatado: `R$ ${convertCurrency(item.custoHoraExtra)}`,
          custokmExtra_formatado: `R$ ${convertCurrency(item.custokmExtra)}`,
        })
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  getListItems() {
    this.loading = true
    this.importTariffService
      .listPagedImportTariff(this.page, this.rows)
      .subscribe({
        // this.tariffService.listPagedTariff(this.page, this.rows).subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  searchListItems() {
    this.loading = true
    this.tariffService
      .searchAllPagedTariff(this.page, this.rows, this.searchForm.model)
      .subscribe({
        next: (response: any) => {
          this.treatResponseSearch(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  downloadLog(item: any) {
    this.importTariffService.downloadLog(item.importTarifarioId).subscribe({
      next: (response: any) => {
        downloadBase64File(
          response.data.fileContent,
          response.data.fileName,
          response.data.type,
        )
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  downloadExcel(item: any) {
    this.importTariffService.downloadExcel(item.importTarifarioId).subscribe({
      next: (response: any) => {
        downloadBase64File(
          response.data.fileContent,
          response.data.fileName,
          response.data.type,
        )
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  editItem(item: any) {
    const dialogRef = this.dialog.open(TariffEditComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      minWidth: '1300px',
      data: item,
    })
    dialogRef.componentInstance.responseEdit.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  changeStatusItem(item: any) {
    let loading = true
    const message = 'Aguarde, atualizando tarifário'
    const model = {
      tarifarioId: item.id,
      ativo: item.ativo.toLowerCase() == 's' ? 'N' : 'S',
    }
    const dialogRef = this.dialog.open(DialogLoadingComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      minWidth: '450px',
      data: { loading: loading, message: message },
    })
    this.tariffService.toggleStatusTariff(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
      },
      error: (err: ErrorRequestModel) => {
        dialogRef.close()
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        loading = false
        dialogRef.close()
        this.uploadList()
      },
    })
  }

  deleteItem(item: any) {
  }

  newTariff() {
    const dialogRef = this.dialog.open(TariffCreateComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
    })
    dialogRef.componentInstance.responseEdit.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  downloadModelTariff() {
    this.loadingModelo = true
    this.tariffService.downloadModelTariff().subscribe({
      next: (response: any) => {
        downloadBase64File(
          response.data.fileContent,
          response.data.fileName,
          response.data.type,
        )
        this.loadingModelo = false
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
        this.loadingModelo = false
      },
      complete: () => {
        this.loadingModelo = false
      },
    })
  }

  importTariff() {
    const dialogRef = this.dialog.open(TariffImportComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      minWidth: '900px',
    })
    dialogRef.componentInstance.responseEdit.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }
}
